<template>
  <div class="hospital">
    <input readonly class="input-btn" v-model="hospitalVal" />
    <el-button class="click-btn" @click="openMaskHospital"></el-button>
    <transition name="el-zoom-in-bottom">
      <div class="mask-hospital" v-if="maskShow" @click="closeMask">
        <div class="hospital-content" @click.stop="">
          <div class="select">
            <span @click="closeMask(1)">清空</span>
            <span @click="confirmHoslital">确定</span>
          </div>
          <section class="title">
            <div
              class="area"
              :class="selectId == 0 ? 'on' : ''"
              @click="changeId(0)"
            >
              <span>{{ provinceVal || "请选择" }}</span>
            </div>
            <div
              class="area"
              :class="selectId == 1 ? 'on' : ''"
              @click="changeId(1)"
            >
              <span v-show="provinceVal">{{ cityVal || "请选择" }}</span>
            </div>
            <div
              class="area"
              :class="selectId == 2 ? 'on' : ''"
              @click="changeId(2)"
            >
              <span v-show="cityVal">{{ hospitalVal || "请选择" }}</span>
            </div>
          </section>
          <hr
            style="height:1px;border:none;border-top:1px solid rgb(216, 216, 216);"
          />
          <ul class="content">
            <transition name="slide-fade">
              <div v-show="showProvince">
                <li
                  v-for="(item, index) in provinceList"
                  :key="index"
                  @click.stop="getProvinceVal(item)"
                  :class="provinceVal == item ? 'active' : ''"
                >
                  {{ item }}
                  <i v-if="provinceVal == item" class="el-icon-check"></i>
                </li>
              </div>
            </transition>
            <transition name="slide-fade">
              <div v-show="showCity">
                <li
                  v-for="(item, index) in cityList"
                  :key="index"
                  @click.stop="getCityVal(item)"
                  v-show="showCity"
                  :class="cityVal == item ? 'active' : ''"
                >
                  {{ item }}
                  <i v-if="cityVal == item" class="el-icon-check"></i>
                </li>
              </div>
            </transition>
            <transition name="slide-fade">
              <div v-show="showHospital">
                <li
                  v-for="(item, index) in hospitalList"
                  :key="index"
                  @click.stop="getHospitalVal(item)"
                  v-show="showHospital"
                  :class="hospitalVal == item ? 'active' : ''"
                >
                  {{ item }}
                  <i v-if="hospitalVal == item" class="el-icon-check"></i>
                </li>
              </div>
            </transition>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "hospitalName",
  props: ["hospitalVal", "hospitalOptions"], //重置时保持一致
  data() {
    return {
      options: [],
      maskShow: false,
      selectId: 0, //默认下划线显示省
      showProvince: true,
      provinceList: [],
      provinceVal: "",
      showCity: false,
      cityList: [],
      cityVal: "",
      showHospital: false,
      hospitalList: [],
      // hospitalVal: '',
      middleList: [] //存储中间值
    };
  },
  watch: {
    hospitalOptions() {
      if (this.hospitalOptions.length > 0) {
        this.options = this.hospitalOptions;
        this.options.forEach(item => {
          this.provinceList.push(item.label);
        });
      }
    }
  },
  methods: {
    // 打开主遮罩
    openMaskHospital() {
      this.maskShow = true;
      document.body.style.overflow = "hidden";
    },
    // 关闭主遮罩
    closeMask(val) {
      // val为1时，为清空内容
      this.maskShow = false;
      document.body.style.overflow = "auto";
      // 重置
      if (val == 1) {
        this.showProvince = true;
        this.selectId = 0;
        this.provinceVal = "";
        this.showCity = false;
        this.cityList = [];
        this.cityVal = "";
        this.showHospital = false;
        this.hospitalList = [];
        this.hospitalVal = "";
        this.middleList = [];
      }
    },
    // 获取省的值
    getProvinceVal(val) {
      this.provinceVal = val;
      this.selectId = 1; // 下划线跳到第二条，市区
      this.showProvince = false;
      this.showCity = true;
      this.cityList = []; // 清空
      this.middleList = [];
      this.cityVal = "";
      this.hospitalVal = "";
      this.options.forEach(item => {
        if (item.label == this.provinceVal) {
          item.children.forEach(item_c => {
            this.cityList.push(item_c.label);
          });
          this.middleList = item.children; //暂时存储
        }
      });
    },
    // 获取市的值
    getCityVal(val) {
      this.cityVal = val;
      this.selectId = 2; // 下划线跳到第三条，医院
      this.showCity = false;
      this.showHospital = true;
      this.hospitalList = [];
      this.hospitalVal = "";
      this.middleList.forEach(item => {
        if (item.label == this.cityVal) {
          item.children.forEach(item_p => {
            this.hospitalList.push(item_p.label);
          });
        }
      });
    },
    getHospitalVal(val) {
      this.hospitalVal = val;
    },
    changeId(val) {
      if (val == 0) {
        this.selectId = 0;
        this.showProvince = true;
        this.showCity = false;
        this.showHospital = false;
      } else if (val == 1) {
        this.selectId = 1;
        this.showProvince = false;
        this.showCity = true;
        this.showHospital = false;
      } else {
        this.selectId = 2;
        this.showProvince = false;
        this.showCity = false;
        this.showHospital = true;
      }
    },
    // 返回选中的医院名称
    confirmHoslital() {
      if (!this.hospitalVal) {
        this.$dialog.toast({ mes: "请选择具体的医院名称" });
        return;
      }
      this.$emit(
        "hospital-val",
        this.hospitalVal,
        this.cityVal,
        this.provinceVal
      );
      this.maskShow = false;
      document.body.style.overflow = "auto";
    },
    // 重置省市的值
    resetPC() {
      this.showProvince = true;
      this.selectId = 0;
      this.provinceVal = "";
      this.showCity = false;
      this.cityList = [];
      this.cityVal = "";
      this.showHospital = false;
      this.hospitalList = [];
      this.hospitalVal = "";
      this.middleList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.mask-hospital {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 442;
  background-color: rgba(0, 0, 0, 0.5);
  .hospital-content {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: #fff;
    z-index: 441;
    .select {
      display: flex;
      justify-content: space-between;
      height: 35px;
      background: #eee;
      span {
        line-height: 35px;
        font-size: 16px;
        color: #666;
        display: inline-block;
        width: 50%;
        text-align: center;
      }
      span:last-child {
        background: #409eff;
        color: #fff;
      }
    }
    .title {
      display: flex;
      justify-content: flex-start;
      padding-left: 0.5rem;
      padding-top: 0.15rem;

      .area {
        margin-right: 0.4rem;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 3.5rem;
        line-height: 26px;
        &.on {
          padding-bottom: 0.1rem;
          border-bottom: 2px solid #409eff;
        }
        span {
          font-weight: 700;
        }
      }
    }
    .content {
      padding-left: 0.5rem;
      padding-bottom: 0.25rem;
      font-size: 16px;
      line-height: 28px;
      overflow-y: auto;
      height: 90%;
      .active {
        color: #409eff;
      }
      li:first-child {
        margin-top: 0.1rem;
      }
    }
  }
}

.hospital {
  .input-btn {
    width: 100%;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
  }
  .click-btn {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 334;
    height: 40px;
  }
}
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}
</style>
